<div class="row mt-5">
    <div class="col-md-3"></div>
    <div class="col-md-6 mt-5">
        <h1 style="display: inline">Access Denied. </h1>
        <p style="display: inline;"><span><button (click)="logOut()">Go to Login Page</button></span></p>
        <h2>You need permission to access this site.</h2>
    </div>
</div>